
export const getPartiesRoleListApi = (query = {}) => {
    const queryString = new URLSearchParams(query).toString();
    return `/party_roles${queryString ? `?${queryString}` : ''}`;
};


// GET Role detail endpoint (if you need slug)
export const getPartiesDetailApi = (params) => {
    return `lease/${params?.leaseSlug}/parties`;
};

// POST new Role
export const addRoleApi = (params) => {
    return `/party_roles`;
};

// PUT edit Role
export const updateRoleApi = (params) => {
    return `/party_roles/${params?.asset_slug}`;
};

// DELETE Role
export const deletePartiesApi = (params) => {
    return `party_roles`;
};

// EXPORT Roles
export const exportPartiesApi = (leaseId) => {
    return `lease/${leaseId}/parties`;
};
